<div class="wrapper limit-width-on-desktop-float" *ngIf="!showDeductionDay">
  <div class="header">
    <h2 class="question-heading">Before you accept the quote we need some details.</h2>
  </div>

  <div class="content">
    <div class="update-email">
      <div class="text-wrapper">
        <p><b>Confirm email address</b></p>
        <p>
          <small>{{ sharedConfig.user.personal_details.email }}</small>
        </p>
      </div>
      <div class="update-btn">
        <a (click)="openUpdateEmailPopup()"><b>Update</b></a>
      </div>
    </div>

    @if (!insurerProviderIsPremia()) {
      <ion-item mode="ios" (click)="openCalendar()">
        <ion-input
          label="Cover start date"
          labelPlacement="stacked"
          type="text"
          readonly="true"
          placeholder="YYYY-MM-DD"
          [(ngModel)]="cover_start_date"
        ></ion-input>
        <ion-icon name="calendar-outline" slot="end" class="calendar-icon"></ion-icon>
        <!-- <ion-datetime
          *ngIf="sharedConfig.isMobileApp"
          #datePicker
          (ionChange)="setCoverStartDate(datePicker.value)"
          displayFormat="YYYY/MM/DD"
          min="{{ minDate }}"
          max="{{ maxDate }}"
          [(ngModel)]="cover_start_date"
        ></ion-datetime>
        <ion-input
          *ngIf="!sharedConfig.isMobileApp"
          type="date"
          #dateDesktopPicker
          (ionChange)="setCoverStartDate(dateDesktopPicker.value)"
          displayFormat="YYYY/MM/DD"
          min="{{ minDate }}"
          max="{{ maxDate }}"
          [(ngModel)]="cover_start_date"
        ></ion-input> -->
      </ion-item>
    }
    <h2 class="question-heading form-header">Enter banking details</h2>
    @if (!insurerProviderIsPremia() && insurer_id !== 'KINGPRICE' && insurer_id !== 'MIWAY' && insurer_id !== 'SANTAMDIRECT') {
      <small>Please note: Your insurer has appointed Brolink to collect your debit order.</small>
    }

    @if (insurerProviderIsPremia()) {
      <div class="form">
        <ion-item mode="ios">
          <ion-input labelPlacement="floating" class="bold-text" [(ngModel)]="premiaBankingDetails.account_holder">
            <div slot="label">
              <ion-text class="standard-input-label">Account holder</ion-text>
            </div>
          </ion-input>
        </ion-item>
        <ion-item mode="ios">
          <ion-input labelPlacement="floating" class="bold-text" [(ngModel)]="premiaBankingDetails.account_number">
            <div slot="label">
              <ion-text class="standard-input-label">Account number</ion-text>
            </div>
          </ion-input>
        </ion-item>
        <ion-item mode="ios" (click)="openPremiaBankPopup()">
          <ion-input labelPlacement="floating" class="bold-text" readonly="true" [value]="premiaBankingDetails.bank_description">
            <div slot="label">
              <ion-text class="standard-input-label">Bank</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
        <ion-item mode="ios">
          <ion-input labelPlacement="floating" readonly="true" class="bold-text" [value]="premiaBankingDetails.branch_description">
            <div slot="label">
              <ion-text class="standard-input-label">Branch</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
        <ion-item mode="ios">
          <ion-input labelPlacement="floating" readonly="true" class="bold-text" [value]="premiaBankingDetails.branch_code">
            <div slot="label">
              <ion-text class="standard-input-label">Branch code</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
        <ion-item mode="ios" (click)="openPremiaAccountTypePopup()">
          <ion-input labelPlacement="floating" class="bold-text" readonly="true" [value]="premiaBankingDetails.account_type_description">
            <div slot="label">
              <ion-text class="standard-input-label">Account Type</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
        <ion-item mode="ios" (click)="openPremiaRelationshipTypePopup()">
          <ion-input labelPlacement="floating" class="bold-text" readonly="true" [value]="premiaBankingDetails.account_relationship_description">
            <div slot="label">
              <ion-text class="standard-input-label">Relationship Type</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
      </div>
    } @else if (insurer_id === 'KINGPRICE') {
      <div class="kp-banner">
        <ion-grid>
          <ion-row>
            <ion-col size="1">
              <ion-icon src="assets/icon/genetic-icons/lightbulb.svg" class="icon-fill-secondary"></ion-icon>
            </ion-col>
            <ion-col>
              <p><b>Please note: </b>King Price will call you to setup up your banking details.</p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    } @else {
      <div class="form">
        <ion-item mode="ios">
          <ion-input
            labelPlacement="floating"
            type="number"
            class="bold-text"
            value="{{ banking_details.account_number }}"
            (input)="accountNumberValueChange($event)"
          >
            <div slot="label">
              <ion-text class="standard-input-label">Account number</ion-text>
            </div>
          </ion-input>
        </ion-item>
        <ion-item mode="ios" (click)="openBankSelectPopup()">
          <ion-input labelPlacement="floating" class="bold-text" readonly="true" [(ngModel)]="banking_details.financial_institution">
            <div slot="label">
              <ion-text class="standard-input-label">Bank</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
        <ion-item mode="ios">
          <ion-input labelPlacement="floating" readonly="true" class="bold-text" [(ngModel)]="branchAndCode">
            <div slot="label">
              <ion-text class="standard-input-label">Branch & code</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
        <ion-item (click)="openDeductionDay()" mode="ios">
          <ion-input labelPlacement="floating" class="bold-text" readonly="true" [(ngModel)]="collection_day">
            <div slot="label">
              <ion-text class="standard-input-label">Deduction day</ion-text>
            </div>
          </ion-input>
          <ion-icon slot="end" class="end-icon" name="chevron-down"></ion-icon>
        </ion-item>
      </div>
    }

    <!-- UPDATE EMAIL -->
    @if (showUpdateEmailPopup) {
      <div class="component-wrapper">
        <div class="component-padding limit-width-on-desktop-float">
          <ion-item lines="none" mode="ios">
            <ion-input labelPlacement="floating" class="bold-text" [value]="sharedConfig.user.personal_details.email" readonly="true">
              <div slot="label">
                <ion-text class="standard-input-label">Current email address</ion-text>
              </div>
            </ion-input>
          </ion-item>
          <ion-item mode="ios">
            <ion-input labelPlacement="floating" type="text" class="bold-text" [(ngModel)]="newEmail">
              <div slot="label">
                <ion-text class="standard-input-label">New email address</ion-text>
              </div>
            </ion-input>
          </ion-item>
        </div>
        <div class="component-button-wrapper">
          <ion-button mode="ios" class="primary-button limit-width-desktop-on-button" expand="block" [disabled]="!newEmail" (click)="updateEmail()"
            >Update
          </ion-button>
          <ion-button mode="ios" class="secondary-button limit-width-desktop-on-button" expand="block" (click)="cancelPopupEmail()"
            >Cancel</ion-button
          >
        </div>
      </div>
    }

    <!-- SELECTING BANK -->
    @if (bankSelectPopup) {
      <div class="component-wrapper">
        <div class="component-padding limit-width-on-desktop-float">
          <ion-item mode="ios">
            <ion-input
              labelPlacement="floating"
              type="text"
              class="text-bold"
              [(ngModel)]="bankSearchText"
              (ngModelChange)="bankSearchValueChange($event)"
            >
              <div slot="label">
                <ion-text class="standard-input-label">Search bank</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <div class="banks-wrapper">
            @if (showPopular && banksPopular?.length > 0) {
              <div>
                <p><b>Popular</b></p>
                <div class="bank-select" (click)="selectBank(bank)" mode="md" *ngFor="let bank of banksPopular">
                  {{ bank.display }}
                </div>
              </div>
            }

            @if (banksFiltered?.length > 0) {
              <div>
                <p><b *ngIf="!bankSearchText">All</b></p>
                <div class="bank-select" (click)="selectBank(bank)" *ngFor="let bank of banksFiltered">
                  {{ bank.display }}
                </div>
              </div>
            } @else {
              <div class="nothing-found-wrapper">
                <h2 class="h2-bold">Hmmm...</h2>
                <p>We couldn't find a bank matching your description. Please check your spelling.</p>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- PREMIA POPUPS -->
    <!-- SELECTING BANK -->
    @if (premiaBankPopup()) {
      <div class="component-wrapper">
        <div class="component-padding limit-width-on-desktop-float">
          <ion-item mode="ios">
            <ion-input
              labelPlacement="floating"
              type="text"
              class="text-bold"
              [ngModel]="premiaBankSearchText()"
              (ngModelChange)="premiaBankSearchText.set($event)"
            >
              <div slot="label">
                <ion-text class="standard-input-label">Search bank</ion-text>
              </div>
            </ion-input>
          </ion-item>

          <div class="banks-wrapper">
            @if (premiaBanksFiltered()?.length > 0) {
              <div>
                @if (!premiaBankSearchText()) {
                  <p><b>All</b></p>
                }
                <div class="bank-select" (click)="selectPremiaBank(bank)" *ngFor="let bank of premiaBanksFiltered()">
                  {{ bank.description }}
                </div>
              </div>
            } @else {
              <div class="nothing-found-wrapper">
                <h2 class="h2-bold">Hmmm...</h2>
                <p>We couldn't find a bank matching your description. Please check your spelling.</p>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- SELECTING ACCOUNT TYPE -->
    @if (premiaAccountTypePopup()) {
      <div class="component-wrapper">
        <div class="component-padding limit-width-on-desktop-float">
          <div class="banks-wrapper">
            @for (accountType of premiaAccountTypes(); track accountType.code) {
              <div class="bank-select" (click)="selectPremiaAccountType(accountType)">
                {{ accountType.description }}
              </div>
            } @empty {
              <div class="nothing-found-wrapper">
                <h2 class="h2-bold">Hmmm...</h2>
                <p>We could not load account types. Please try again later.</p>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- SELECTING RELATIONSHIP TYPE -->
    @if (premiaRelationshipTypePopup()) {
      <div class="component-wrapper">
        <div class="component-padding limit-width-on-desktop-float">
          <div class="banks-wrapper">
            @for (relationshipType of premiaRelationshipTypes(); track relationshipType.code) {
              <div class="bank-select" (click)="selectPremiaRelationshipType(relationshipType)">
                {{ relationshipType.description }}
              </div>
            } @empty {
              <div class="nothing-found-wrapper">
                <h2 class="h2-bold">Hmmm...</h2>
                <p>We could not load relationship types. Please try again later.</p>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
<div class="footer-button-wrapper">
  <div class="fade"></div>
  <div class="footer-button-background">
    <ion-button mode="ios" class="footer-button limit-width-desktop-on-button" (click)="continue()" [disabled]="!canContinue()" expand="block">
      Next
    </ion-button>
  </div>
</div>
<!-- DEDUCTION DAY -->
<div class="backdrop" *ngIf="showDeductionDay"></div>
<div class="popup-dates limit-width-on-desktop-float" *ngIf="showDeductionDay">
  <div class="text-center">
    <h2 class="h2-bold">Select deduction day</h2>
  </div>
  <div class="dates">
    <div class="date-wrapper" *ngFor="let collectionDate of collectionDates" (click)="onCollectionDaySelected(collectionDate)">
      {{ collectionDate.day_ordinal_display_name }}
    </div>
  </div>
</div>

<custom-popup *ngIf="showEmailChangePopup">
  <div class="heading">
    <h2 class="h2-bold">Enter password</h2>
  </div>
  <div class="sub-header">
    <p>Please enter your password to confirm your new email address : {{ newEmail }}</p>
  </div>
  <div class="input-wrapper">
    <ion-item mode="ios">
      <ion-input labelPlacement="floating" type="password" [(ngModel)]="passwordField">
        <div slot="label">
          <ion-text class="standard-input-label">Password</ion-text>
        </div>
      </ion-input>
    </ion-item>
  </div>
  <div class="buttons-wrapper">
    <ion-button mode="ios" class="primary-button" (click)="confirmEmailChange()"> Confirm </ion-button>
    <ion-button mode="ios" class="secondary-button" (click)="dismissCustomPopup()"> Cancel </ion-button>
  </div>
</custom-popup>

<popup-with-dismiss-button *ngIf="sharedConfig.showPopupWithDismissButton"></popup-with-dismiss-button>
<popup-calendar
  *ngIf="sharedConfig.showCalendarPopup"
  [heading]="'Cover start date'"
  (setDate)="setCoverStartDate($event)"
  [dateFormat]="'date'"
  [maxDate]="maxDate"
  [minDate]="minDate"
  [ngModal]="cover_start_date"
></popup-calendar>

<!-- TODO ALL OTHER POPUPS SHOULD BE REPLACED BY THIS GENERIC POPUP -->
<popup-dialog id="quote.banking.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>
